// Lubex header navigation — DOM-based hover tracking, no time-based delays.
// Applies to ALL <header-menu> dropdowns (lubex mega-menus AND standard
// Dawn dropdowns like Derma-Line) so the hover UX is consistent.
//
// Behaviour:
//   - Hover any top-level summary  -> open this menu, close any other open one
//   - Stay over summary, its pseudo-bridge (in CSS), or panel  -> menu remains
//   - Cursor leaves the entire <details> tree (down past the panel,
//     sideways to another menu item)                  -> close immediately
//   - Touch / coarse pointer devices fall back to native click-to-toggle
//
// The CSS pseudo on summary fills the gap between summary text and the
// mega-menu panel so the cursor never "leaves" the details element while
// transiting from one to the other.
(function () {
  'use strict';

  function getSummary(menu) {
    var children = menu.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName && children[i].tagName.toLowerCase() === 'summary') {
        return children[i];
      }
    }
    return null;
  }

  function setup() {
    var menus = Array.prototype.slice.call(document.querySelectorAll('header-menu > details'));
    if (menus.length === 0) return;

    var coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (coarsePointer) return;

    function closeMenu(menu) {
      if (!menu.hasAttribute('open')) return;
      menu.removeAttribute('open');
      var summary = getSummary(menu);
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }

    function openMenu(menu) {
      menus.forEach(function (other) {
        if (other !== menu) closeMenu(other);
      });
      if (!menu.hasAttribute('open')) {
        menu.setAttribute('open', '');
        var summary = getSummary(menu);
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    }

    menus.forEach(function (menu) {
      if (menu.dataset.lubexHoverInit) return;
      menu.dataset.lubexHoverInit = '1';
      var summary = getSummary(menu);
      if (!summary) return;

      summary.addEventListener('mouseenter', function () {
        openMenu(menu);
      });

      // mouseleave fires when the cursor leaves the element AND ALL its
      // descendants (including the abs-positioned panel and the pseudo
      // bridge below the summary). That is exactly the "menu region" we
      // want to track for closing.
      menu.addEventListener('mouseleave', function () {
        closeMenu(menu);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
